import { DynamicModuleUiModuleBody, DynamicModuleUiModuleBodyModuleTypeEnum, EntitlementType } from '../../../API';
import generateId from '../../../utils/generateId';
import { NewModuleFunction } from '../../../utils/layouts';

export const blankDynamicModule: NewModuleFunction<DynamicModuleUiModuleBody> = (module) => ({
  moduleType: DynamicModuleUiModuleBodyModuleTypeEnum.DYNAMIC_MODULE,
  moduleId: generateId(),
  schemaId: '',
  data: {},
  entitlements: [EntitlementType.ANON, EntitlementType.FREE, EntitlementType.SUB],
  ...module
});
